import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hygiene',
  templateUrl: './hygiene.component.html',
  styleUrls: ['./hygiene.component.scss']
})
export class HygieneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
